import { Check, Copy, KeyRound } from "lucide-react";
import { useState } from "react";

export function RecoveryCodeNotice({ code, onContinue }: { code: string; onContinue: () => void }) {
  const [copied, setCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);

  async function copyCode() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setCopyFailed(false);
    } catch {
      setCopyFailed(true);
    }
  }

  return (
    <section className="recovery-notice" aria-labelledby="recovery-title">
      <span className="detail-icon"><KeyRound size={28} /></span>
      <h2 id="recovery-title">请保存账号恢复码</h2>
      <p>忘记密码时需要手机号和此恢复码。出于安全原因，系统以后不会再次显示这组号码。</p>
      <div className="recovery-code"><strong>{code}</strong><button type="button" onClick={() => void copyCode()}>{copied ? <Check /> : <Copy />}{copied ? "已复制" : "复制"}</button></div>
      {copyFailed ? <small className="form-error" role="alert">浏览器未允许复制，请长按恢复码手动复制。</small> : null}
      <small>每次修改或找回密码都会生成新的恢复码，旧码立即失效。</small>
      <button className="primary-button" type="button" onClick={onContinue}>我已保存，继续</button>
    </section>
  );
}
